





































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";

export interface Item {
  id: number;
  value: string;
  [key: string]: unknown;
}

@Component
export default class SelectDialog extends Vue {
  @Prop({ default: [] }) items!: Item[];
  @Prop({ default: "一覧" }) title!: string;
  @Prop({ default: false }) isActive!: boolean;
  @Prop({ default: "" }) itemValue!: string;
  @Prop({ default: [] }) columns!: string[];
  @Prop({ default: "300" }) width!: string;

  // 選択した
  private selectedItem: Item = {
    id: 0,
    value: "",
    [this.itemValue]: ""
  };

  //プレビュー
  @Emit()
  private select(item: Item) {
    return item;
  }

  //キャンセル
  @Emit()
  private cancel() {
    return;
  }

  private getColumns() {
    return this.columns;
  }
}
